module.exports = __webpack_public_path__ + "static/media/Digital System Design using Verilog.cc1226b5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ECE/Digital System Design using Verilog.pdf
// module id = 114
// module chunks = 0